import { render, staticRenderFns } from "./AddCertisDialog.vue?vue&type=template&id=5e979314"
import script from "./AddCertisDialog.vue?vue&type=script&lang=js"
export * from "./AddCertisDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports